import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class ScheduledOrderComponent extends Component {
  static readonly TYPE_ID: string = '18c2e75e24d940a1b3da7904ac55cba3';

  constructor(
    public readonly serviceId: string,
    public readonly reservationId: string | null = null,
    public readonly groupId: string | null = null,
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return ScheduledOrderComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ScheduledOrderComponent {
    return new ScheduledOrderComponent(
        MapUtils.get<string>(map, 'serviceId'),
        MapUtils.getOrNull<string>(map, 'reservationId'),
        MapUtils.getOrNull<string>(map, 'groupId'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'serviceId': this.serviceId,
      'reservationId': this.reservationId,
      'groupId': this.groupId,
    };
  }

  clone(): this {
    return new ScheduledOrderComponent(
        this.serviceId,
        this.reservationId,
        this.groupId,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.serviceId === this.serviceId &&
        other.reservationId === this.reservationId &&
        other.groupId === this.groupId;
  }
}

export class ScheduledOrderComponentBuilder extends DataModelBuilder<ScheduledOrderComponent> {
  build(context: SerializationContext, map: SerializedData): ScheduledOrderComponent {
    return ScheduledOrderComponent.fromMap(context, map);
  }
}
